import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sd-cross",
  "use": "sd-cross-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"sd-cross\"><path d=\"M10.034 11.625l-5.205 5.204A1.125 1.125 0 006.42 18.42l5.205-5.204 5.204 5.205a1.125 1.125 0 001.591-1.591l-5.204-5.205 5.205-5.205a1.125 1.125 0 00-1.591-1.59l-5.205 5.204L6.42 4.829A1.125 1.125 0 004.83 6.42l5.204 5.205z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol